import { render } from "./DLayanan.vue?vue&type=template&id=1d7ce2f7"
import script from "./DLayanan.vue?vue&type=script&lang=js"
export * from "./DLayanan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__